module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-ai_btn-2bd5d4592ce351e54b3c4c332f377813.png";